import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const OperatorsList = ({ tb, operators = [], operatorsFilter = '', setOperatorsFilter = () => {},openCreateModal, loadOperatorsByTopBasePage = () => {}, employees = [], editingOperatorByTopBase, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {}, expandedOperatorByTopBase = {}, toggleOperator = () => {} }) => {
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong>Операторы этой ТОП-базы</strong>
        <div>
          <button className={styles.smallBtn} onClick={() => openCreateModal('operator', { top_base: tb.id, top_base_name: tb.name })}>Добавить оператора</button>
        </div>
      </div>
      <div style={{ marginTop: 8 }}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByTopBasePage(tb.id, 1, operatorsFilter || '') }} />

        </div>
        {(operators && operators.length) ? (
          <>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Сотрудник</th>
                  <th>Номер телефона</th>
                  <th>Дополнительный ном.тел</th>
                  <th>Создано</th>
                  <th>Статус</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tbody>
                {operators.filter(op => {
                  const q = (operatorsFilter || '').toLowerCase()
                  if (!q) return true
                  const emp = op.employee_name || String(op.employee)
                  return (emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q))
                }).map((op, index) => (
                  <React.Fragment key={op.id}>
                    <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(tb.id, op.id)}>
                      <td>{index + 1}</td>
                      <td>{op.employee_name || op.employee}</td>
                      <td>{op.employee_phone || '-'}</td>
                      <td>{op.phone || '-'}</td>
                      <td>{op.created_at}</td>
                      <td>{op.is_active ? 'Активен' : 'Неактивен'}</td>
                      <td>
                        <button className={styles.smallBtn} onClick={(ev) => { ev.stopPropagation(); startEdit('operator', { topBase: tb.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}>Изменить</button>
                      </td>
                    </tr>
                    {expandedOperatorByTopBase[tb.id] === op.id && (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                          <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                            {/* Документы оператора */}
                            <div style={{ marginTop: 16, borderTop: '1px solid #e0e0e0', paddingTop: 12 }}>
                              <strong>Документы оператора:</strong>
                              {op.documents && op.documents.length > 0 ? (
                                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id} style={{ marginBottom: 8 }}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0d6efd', textDecoration: 'none' }}>
                                        {doc.file_name}
                                      </a>
                                      <span style={{ marginLeft: 8, color: '#666', fontSize: '12px' }}>
                                        ({(doc.file_size / 1024).toFixed(1)} KB) - {new Date(doc.uploaded_at).toLocaleString('ru-RU')}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div style={{ marginTop: 8, color: '#666', fontStyle: 'italic' }}>Нет документов</div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {editingOperatorByTopBase[tb.id] === op.id && (
                      <tr>
                        <td colSpan={7}>
                          <div style={{ padding: 8 }}>
                            <label>Сотрудник</label>
                            <select value={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                              <option value="">— Выберите сотрудника —</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{emp.label}</option>))}
                            </select>
                            <label style={{ marginLeft: 8 }}>Телефон</label>
                            <input value={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>Активен</label>
                            <input type="checkbox" checked={(editPayloads[`operator_${tb.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`operator_${tb.id}_${op.id}`]: { ...p[`operator_${tb.id}_${op.id}`], is_active: e.target.checked } }))} />
                            
                            <div style={{ marginTop: 8 }}>
                              <label>Документы</label>
                              <input 
                                type="file" 
                                multiple 
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  const files = Array.from(e.target.files || [])
                                  setEditPayloads(p => ({ 
                                    ...p, 
                                    [`operator_${tb.id}_${op.id}`]: { 
                                      ...p[`operator_${tb.id}_${op.id}`], 
                                      newDocuments: files 
                                    } 
                                  }))
                                }}
                              />
                              {op.documents && op.documents.length > 0 && (
                                <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                  <strong>Текущие документы:</strong>
                                  <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                    {op.documents.map(doc => (
                                      <li key={doc.id}>
                                        <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                          {doc.file_name}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            
                            <div style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('operator', { topBase: tb.id, opId: op.id })}>Сохранить</button>
                              <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('operator', { topBase: tb.id })}>Отмена</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            {(!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
              <div className={styles.pagination}>
                <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByTopBasePage(tb.id, (operatorsPagination.page || 1) - 1)}>Пред.</button>
                <span>Стр. {operatorsPagination.page || 1} — Всего: {operatorsPagination.count}</span>
                <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByTopBasePage(tb.id, (operatorsPagination.page || 1) + 1)}>След.</button>
              </div>
            )}
          </>
        ) : (
          <div>Операторы не найдены</div>
        )}
      </div>
    </div>
  )
}

export default OperatorsList
